// extracted by mini-css-extract-plugin
module.exports = {"aboutContainer":"about-module--aboutContainer--3anvE","container":"about-module--container--17zLm"};